import React from "react";

export const COMMON_TIMEZONES = [
  { label: "UTC", value: "UTC" },
  { label: "Bangkok / Jakarta (ICT, UTC+7)", value: "Asia/Bangkok" },
  { label: "Singapore / KL (SGT, UTC+8)", value: "Asia/Singapore" },
  { label: "Taipei / Beijing (CST, UTC+8)", value: "Asia/Taipei" },
  { label: "Tokyo / Seoul (JST, UTC+9)", value: "Asia/Tokyo" },
  { label: "Kolkata / Mumbai (IST, UTC+5:30)", value: "Asia/Kolkata" },
  { label: "Dubai (GST, UTC+4)", value: "Asia/Dubai" },
  { label: "London (GMT/BST)", value: "Europe/London" },
  { label: "Paris / Berlin (CET/CEST)", value: "Europe/Paris" },
  { label: "New York (EST/EDT)", value: "America/New_York" },
  { label: "Chicago (CST/CDT)", value: "America/Chicago" },
  { label: "Los Angeles (PST/PDT)", value: "America/Los_Angeles" },
  { label: "Sydney (AEST/AEDT)", value: "Australia/Sydney" },
  { label: "Auckland (NZST/NZDT)", value: "Pacific/Auckland" },
];

export function browserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}

export function fmtSlotInTz(isoStr: string, tz: string): string {
  try {
    return new Date(isoStr).toLocaleString("en-US", {
      timeZone: tz,
      weekday: "long", year: "numeric", month: "long", day: "numeric",
      hour: "2-digit", minute: "2-digit", timeZoneName: "short",
    });
  } catch {
    return new Date(isoStr).toLocaleString();
  }
}

interface Props {
  value: string;
  onChange: (tz: string) => void;
  style?: React.CSSProperties;
}

export default function TimezoneSelect({ value, onChange, style }: Props) {
  const known = COMMON_TIMEZONES.some(t => t.value === value);
  return (
    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      style={{ padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 13, background: "white", ...style }}
    >
      {!known && <option value={value}>{value}</option>}
      {COMMON_TIMEZONES.map(t => (
        <option key={t.value} value={t.value}>{t.label}</option>
      ))}
    </select>
  );
}
